// extracted by mini-css-extract-plugin
export default {"container":"About_container_8iBLY","row":"About_row_iOcSM","image":"About_image_T1SRr","text":"About_text_FToZP","title":"About_title_pYURM","subtext":"About_subtext_oZ5Yr"};